<template>
<PattanButton :states="buttonStates" :startState="0" />&nbsp;
  <label class="pb-2">These materials will not be available to attendees.</label>
</template>

<script>
import PattanButton from '@/components/PattanButton'

export default {
    name: 'MaterialButton',

    components: {
        PattanButton,
    },

    data() {
        return {
            buttonStates: [

                {
                    label: 'Add presentation materials',
                    color: 'var(--phoenix-link-color)',
                    onClick: this.addButtonClickHandler,
                },
            ],
        }
    },

    methods: {
        addButtonClickHandler() {
            this.$router.push({ name: 'materialview', params: { sessionId: this.sessionId, presentationMaterial: true } })
        },
    },

    props: {
        sessionId: Number,
    }
}
</script>
<style scoped>
.btn {
    width: 17em;
}
</style>